import { Action, createReducer, on } from '@ngrx/store';
import { StateBuilder } from '../../../model/state.builder';
import { AccountActions } from './account.actions';
import { IAccountState } from './account.state';

export const initialAccountState: IAccountState = {
  model: undefined,
  data: undefined,
  uiState: undefined
};

const accountReducerFn = createReducer(
  initialAccountState,
  on(AccountActions.reset, (state: IAccountState, action) => {
    return new StateBuilder<IAccountState>(initialAccountState).build();
  }),
  on(AccountActions.load, (state: IAccountState, action) => {
    return new StateBuilder<IAccountState>(state).toLoading().build();
  }),
  on(AccountActions.loadSuccess, (state: IAccountState, action) => {
    return new StateBuilder<IAccountState>(state, action).toLoaded().build();
  }),
  on(AccountActions.submit, (state: IAccountState, action) => {
    return new StateBuilder<IAccountState>(state, action).toLoading().build();
  }),
  on(AccountActions.submitSuccess, (state: IAccountState, action) => {
    return new StateBuilder<IAccountState>(state, action).toLoaded().build();
  })
);

export function accountReducer(state: IAccountState | undefined, action: Action) {
  return accountReducerFn(state, action);
}
